import { useAuth } from "../auth/useAuth";
import { KEYCLOAK_CONFIG } from "../keycloak";
import { useOrgBranding } from "../branding/orgBranding";
import { getOrgAlias } from "../utils/tokenUtils";

/**
 * Applies the branding of the signed-in user's organization (colours, logo).
 * Mounted inside AuthGuard next to UserInitializer; renders nothing.
 */
export const BrandingInitializer = () => {
  const { token } = useAuth();
  const alias = token ? getOrgAlias(token) : null;
  useOrgBranding(alias, KEYCLOAK_CONFIG.realm);
  return null;
};

export default BrandingInitializer;
